import React from 'react';

/**
 * Page-wide decorative block flow.
 *
 * A fixed, full-viewport layer that sits above section background colors and
 * below every content block. Blocks enter above the viewport on the right,
 * fall down the right gutter, turn at the lower edge and slide out through the
 * left edge. Staggered so a new block starts roughly every 1.6s with no pause.
 *
 * Purely decorative: pointer-events are disabled and motion stops for
 * reduced-motion users.
 */
const blocks = [{
  id: 'emerald',
  color: '#3ddc6b',
  glow: 'rgba(61, 220, 107, 0.35)',
  delay: '0s'
}, {
  id: 'cyan',
  color: '#38d3e0',
  glow: 'rgba(56, 211, 224, 0.35)',
  delay: '-1.6s'
}, {
  id: 'cobalt',
  color: '#2f6bd8',
  glow: 'rgba(47, 107, 216, 0.35)',
  delay: '-3.2s'
}, {
  id: 'gold',
  color: '#f5b027',
  glow: 'rgba(245, 176, 39, 0.35)',
  delay: '-4.8s'
}, {
  id: 'copper',
  color: '#e07a34',
  glow: 'rgba(224, 122, 52, 0.35)',
  delay: '-6.4s'
}];
export function BlockFlowLayer() {
  return <div className="block-flow-layer" aria-hidden="true" data-id="element-16" data-mp="3kl6tqd2ijwbe">
      {blocks.map(block => <span key={block.id} className="flow-block" style={{
      backgroundColor: block.color,
      animationDelay: block.delay,
      boxShadow: `0 14px 26px -12px rgba(0,0,0,0.65), 0 0 26px ${block.glow}, inset 3px 3px 0 rgba(255,255,255,0.4), inset -4px -5px 0 rgba(0,0,0,0.25)`
    }} data-id="element-17" data-mp="5ssporc31z1k" />)}
    </div>;
}